module.exports = __webpack_public_path__ + "img/me_profile.fa8a48e1.jpg";